import React, { createContext, useContext, useState, useMemo } from "react";

const CategoryFilterContext = createContext(null);

export function CategoryFilterProvider({ children }) {
  const [showPromotions, setShowPromotions] = useState(false);
  const [showMustOrder, setShowMustOrder] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showPassover, setShowPassover] = useState(false);
  const [showReturnedToStock, setShowReturnedToStock] = useState(false);
  const [showReturnedToAssortment, setShowReturnedToAssortment] = useState(false);
  /** מיון מוצרים בדף מוצרי קטגוריה: סדר מערכת או א-ב */
  const [productSortMode, setProductSortMode] = useState("default");

  const value = useMemo(
    () => ({
      showPromotions,
      showMustOrder,
      showNew,
      showPassover,
      showReturnedToStock,
      showReturnedToAssortment,
      productSortMode,
      setProductSortMode,
      setShowPromotions,
      setShowMustOrder,
      setShowNew,
      setShowPassover,
      setShowReturnedToStock,
      setShowReturnedToAssortment,
      activeFiltersCount:
        [showPromotions, showMustOrder, showNew, showPassover, showReturnedToStock, showReturnedToAssortment].filter(Boolean).length +
        (productSortMode === "alphabetical" ? 1 : 0),
    }),
    [showPromotions, showMustOrder, showNew, showPassover, showReturnedToStock, showReturnedToAssortment, productSortMode]
  );

  return (
    <CategoryFilterContext.Provider value={value}>
      {children}
    </CategoryFilterContext.Provider>
  );
}

export function useCategoryFilter() {
  const ctx = useContext(CategoryFilterContext);
  if (!ctx) {
    return {
      showPromotions: false,
      showMustOrder: false,
      showNew: false,
      showPassover: false,
      showReturnedToStock: false,
      showReturnedToAssortment: false,
      productSortMode: "default",
      setProductSortMode: () => {},
      setShowPromotions: () => {},
      setShowMustOrder: () => {},
      setShowNew: () => {},
      setShowPassover: () => {},
      setShowReturnedToStock: () => {},
      setShowReturnedToAssortment: () => {},
      activeFiltersCount: 0,
    };
  }
  return ctx;
}
